import roundTick from "../../assets/images/round-tick.svg";
import tick from "../../assets/images/tick.svg";

export interface PackageInfoState {
  name: string;
  description: string;
  features: Array<string>;
}

const PackageInformationView = (items: Array<PackageInfoState>) => (
  <div className="px-8 pt-8 w-full">
    {items.map((item, index) => (
      <div key={`cart-page-item-list-${index}`} className="mb-8 w-full">
        <div className="flex justify-start items-start">
          <img src={roundTick} alt="Tick" />
          <div className="ml-2">
            <h1 className="font-semibold text-lg">
              {item.name}
            </h1>
            <p
              className="mt-2 text-grey-scale-slate"
              dangerouslySetInnerHTML={{ __html: item.description }}
            />
            <div className="mt-4 w-full">
              {item.features.map((feature: string, index: number) => (
                <div
                  key={index}
                  className="flex items-center justify-start w-full"
                >
                  <img src={tick} alt="Tick" />
                  <span
                    className="list-feature-item ml-2"
                    dangerouslySetInnerHTML={{ __html: feature }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        {index !== items.length - 1 && (
          <hr className="text-grey-scale-sleet mt-8" />
        )}
      </div>
    ))}
  </div>
);

export default PackageInformationView;
